import { render, staticRenderFns } from "./ProductBundleOption.vue?vue&type=template&id=22aee275&scoped=true&"
import script from "./ProductBundleOption.vue?vue&type=script&lang=js&"
export * from "./ProductBundleOption.vue?vue&type=script&lang=js&"
import style0 from "./ProductBundleOption.vue?vue&type=style&index=0&id=22aee275&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22aee275",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22aee275')) {
      api.createRecord('22aee275', component.options)
    } else {
      api.reload('22aee275', component.options)
    }
    module.hot.accept("./ProductBundleOption.vue?vue&type=template&id=22aee275&scoped=true&", function () {
      api.rerender('22aee275', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default/components/core/ProductBundleOption.vue"
export default component.exports